// Packages
import { useState } from 'react';
import { Box } from "@mui/material";

import { isEmpty } from "lodash";

export const getClientsTableColumns = ({
  auth,
  columnHelper,
  theme,
  callbacks
}) => {
  return [
    columnHelper.accessor(row => (row.clientName && row.formattedMacAddress) ?? "-", {
      id: "clientName",
      header: "Client",
      cell: (info) => {
        const ClientNameContainer = ({ info }) => {
          const [isHovered, setIsHovered] = useState(false);
          const { clientName, formattedMacAddress, clientId } = info.row.original;

          if (isEmpty(clientName)) return <Box>-</Box>

          return (
            <Box
              sx={{
                cursor: "pointer",
                textDecoration: 'underline',
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => callbacks.handelClient && callbacks.handelClient(clientId)}
            >
              {isHovered ? (formattedMacAddress || "-") : (clientName || "-")}
            </Box>
          );
        };

        return (
          <ClientNameContainer {...{ info }} />
        )
      },
    }),
    columnHelper.accessor(row => row.ssid ?? "-", {
      id: "ssid",
      header: "SSID",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.ipAddress ?? "-", {
      id: "ipAddress",
      header: "IP",
      cell: (info) => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.formattedSignal ?? "-", {
      id: "formattedSignal",
      header: "Signal",
      cell: (info) => <>{info.getValue()}</>,
    }),
  ].filter(Boolean);
}